module.exports = __webpack_public_path__ + "img/SP-Profi-Profiles.3286b37e.jpg";